export type VideoCategory = "movie" | "tv" | "variety";

export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  category: VideoCategory;
  genre: string[];
  year: number;
  region: string;
  cast: string[];
  director: string;
  description: string;
  status: "完结" | "连载";
  rating: number;
  popularity: number;
  updateDate: string;
  duration: string;
}

export const categoryMeta: Record<
  VideoCategory,
  { name: string; intro: string; slug: string }
> = {
  movie: {
    name: "电影",
    intro: "精选院线大片与经典电影，涵盖动作、爱情、科幻、悬疑等多种类型，满足不同口味的观影选择。",
    slug: "movie",
  },
  tv: {
    name: "电视剧",
    intro: "热播剧集与口碑佳作汇聚，都市情感、古装传奇、悬疑刑侦一应俱全，追剧从此不迷路。",
    slug: "tv",
  },
  variety: {
    name: "综艺",
    intro: "音乐、美食、推理、户外真人秀等多元综艺内容，轻松解压，快乐随时在线。",
    slug: "variety",
  },
};

export const videos: VideoItem[] = [
  // ===== 电影 =====
  {
    id: "v-star-promise",
    title: "星辰之约",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20romance%20movie%20poster%2C%20lone%20figure%20standing%20under%20a%20vast%20starry%20night%20sky%20with%20glowing%20pink%20nebula%2C%20dramatic%20lighting%2C%20deep%20navy%20background%2C%20elegant%20composition%2C%20high%20detail%2C%20moody%20atmosphere&width=600&height=900&seq=pinkv-movie-01&orientation=portrait",
    category: "movie",
    genre: ["科幻", "爱情", "剧情"],
    year: 2025,
    region: "中国大陆",
    cast: ["林知遥", "陆沉舟", "苏晚晴"],
    director: "陈牧野",
    description:
      "天文学家顾星野在海拔四千米的观测站遇见神秘女孩星河，两人因一场跨越十年的流星雨结下不解之缘。当真相层层揭开，他们必须在宇宙的浩瀚与时间的无情之间，做出关于爱与守候的选择。",
    status: "完结",
    rating: 9.1,
    popularity: 9820,
    updateDate: "2025-06-18",
    duration: "132分钟",
  },
  {
    id: "v-night-chase",
    title: "暗夜追凶",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20movie%20poster%2C%20rain%20soaked%20city%20alley%20at%20night%20with%20neon%20pink%20reflections%2C%20silhouette%20of%20detective%2C%20gritty%20dark%20tone%2C%20cinematic%20mood%2C%20high%20contrast%20lighting%2C%20suspenseful%20atmosphere&width=600&height=900&seq=pinkv-movie-02&orientation=portrait",
    category: "movie",
    genre: ["悬疑", "犯罪", "动作"],
    year: 2025,
    region: "中国大陆",
    cast: ["高远山", "沈青河", "白若冰"],
    director: "吴长风",
    description:
      "连环失踪案背后隐藏着尘封十五年的秘密。刑警队长高远山在追查真相的过程中，逐渐发现案件与自己的过往有着千丝万缕的联系。当迷雾散尽，正义与执念的边界变得模糊不清。",
    status: "完结",
    rating: 8.7,
    popularity: 8760,
    updateDate: "2025-05-30",
    duration: "118分钟",
  },
  {
    id: "v-changan-wind",
    title: "风起长安",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20historical%20Chinese%20movie%20poster%2C%20ancient%20palace%20under%20dramatic%20crimson%20and%20pink%20sunset%2C%20armored%20warrior%20with%20cape%2C%20grand%20architecture%2C%20cinematic%20epic%20composition%2C%20rich%20golden%20detail%2C%20majestic%20atmosphere&width=600&height=900&seq=pinkv-movie-03&orientation=portrait",
    category: "movie",
    genre: ["历史", "动作", "剧情"],
    year: 2024,
    region: "中国大陆",
    cast: ["萧云策", "楚凝霜", "慕容瑾"],
    director: "南宫鹤",
    description:
      "盛世长安的繁华之下暗流涌动。年轻将军萧云策受命护送神秘的西域使团入京，却卷入了一场关乎王朝命运的惊天阴谋。烽火连天处，他必须用刀剑与智慧守护心中的家国大义。",
    status: "完结",
    rating: 8.9,
    popularity: 8120,
    updateDate: "2024-11-12",
    duration: "145分钟",
  },
  {
    id: "v-summer-echo",
    title: "夏日回声",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20youth%20romance%20movie%20poster%2C%20two%20teenagers%20on%20bicycle%20by%20sunny%20seaside%20in%20summer%2C%20warm%20pink%20golden%20sunlight%2C%20soft%20film%20grain%2C%20breezy%20dreamy%20tone%2C%20gentle%20emotional%20atmosphere&width=600&height=900&seq=pinkv-movie-04&orientation=portrait",
    category: "movie",
    genre: ["爱情", "青春", "剧情"],
    year: 2024,
    region: "中国大陆",
    cast: ["许清和", "叶知秋", "顾北城"],
    director: "温柔",
    description:
      "高考结束的那个夏天，许清和在小镇的海边遇见了转学来的叶知秋。短暂的相遇里，两个人交换了关于未来的所有秘密。多年后当他们重新回到这片海，青春的回声依然清晰如昨。",
    status: "完结",
    rating: 9.0,
    popularity: 7640,
    updateDate: "2024-08-20",
    duration: "108分钟",
  },
  {
    id: "v-deep-voyage",
    title: "深海迷航",
    cover:
      "https://readdy.ai/api/search-image?query=adventure%20deep%20sea%20movie%20poster%2C%20submarine%20descending%20into%20dark%20ocean%20with%20glowing%20pink%20bioluminescent%20creatures%2C%20mysterious%20underwater%20canyon%2C%20cinematic%20teal%20and%20magenta%20lighting%2C%20epic%20scale%2C%20suspenseful%20undertone&width=600&height=900&seq=pinkv-movie-05&orientation=portrait",
    category: "movie",
    genre: ["冒险", "科幻", "灾难"],
    year: 2025,
    region: "中国香港",
    cast: ["何启帆", "罗咏恩", "马千帆"],
    director: "郭远东",
    description:
      "一支国际科考队深入马里亚纳海沟，探寻沉没百年的神秘航船。当深海探测器传回无法解释的信号，船员们发现这片黑暗中潜藏的秘密远比想象中更加危险。",
    status: "完结",
    rating: 8.4,
    popularity: 6980,
    updateDate: "2025-07-02",
    duration: "124分钟",
  },
  {
    id: "v-silent-confession",
    title: "无声告白",
    cover:
      "https://readdy.ai/api/search-image?query=emotional%20drama%20movie%20poster%2C%20woman%20in%20soft%20pink%20dress%20standing%20by%20rainy%20window%2C%20melancholic%20mood%2C%20muted%20tones%20with%20subtle%20warm%20light%2C%20minimal%20elegant%20composition%2C%20artistic%20cinematic%20photography&width=600&height=900&seq=pinkv-movie-06&orientation=portrait",
    category: "movie",
    genre: ["剧情", "家庭", "爱情"],
    year: 2023,
    region: "中国大陆",
    cast: ["周静姝", "谭书言", "林志文"],
    director: "苏念安",
    description:
      "一场突如其来的意外，让原本平静的家庭陷入沉默。母亲周静姝用三十年如一日的坚守，诠释了那些从未说出口的爱。这是一部关于理解、原谅与和解的深情之作。",
    status: "完结",
    rating: 9.3,
    popularity: 6520,
    updateDate: "2023-10-15",
    duration: "116分钟",
  },
  {
    id: "v-edge-speed",
    title: "疾速边缘",
    cover:
      "https://readdy.ai/api/search-image?query=high%20octane%20action%20racing%20movie%20poster%2C%20sports%20car%20drifting%20through%20city%20under%20neon%20pink%20lights%2C%20speed%20blur%20motion%2C%20dynamic%20explosive%20composition%2C%20dramatic%20dark%20background%2C%20energetic%20atmosphere&width=600&height=900&seq=pinkv-movie-07&orientation=portrait",
    category: "movie",
    genre: ["动作", "赛车", "犯罪"],
    year: 2025,
    region: "美国",
    cast: ["杰克·雷纳", "艾玛·斯通", "卢卡斯·格雷"],
    director: "丹尼尔·福德",
    description:
      "退役赛车手杰克被迫重返地下赛车圈，只为偿还弟弟欠下的巨债。在速度与生死的边缘，他必须跑赢对手、跑赢时间，更要跑赢自己心中的恐惧。",
    status: "完结",
    rating: 8.2,
    popularity: 7410,
    updateDate: "2025-04-25",
    duration: "127分钟",
  },
  {
    id: "v-time-letter",
    title: "时光信笺",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20romance%20movie%20poster%2C%20vintage%20letter%20and%20pocket%20watch%20floating%20with%20soft%20pink%20light%20particles%2C%20dreamy%20blurred%20background%2C%20magical%20warm%20glow%2C%20whimsical%20elegant%20composition%2C%20ethereal%20mood&width=600&height=900&seq=pinkv-movie-08&orientation=portrait",
    category: "movie",
    genre: ["奇幻", "爱情", "剧情"],
    year: 2024,
    region: "中国大陆",
    cast: ["顾念之", "宋清欢", "裴时予"],
    director: "叶澜",
    description:
      "旧书店老板顾念之偶然收到一封来自十年前的来信。写信的女孩宋清欢说，她能够看到未来。两个时空交错的灵魂，用一封封信笺改写彼此的命运，也书写下一段跨越时间的浪漫。",
    status: "完结",
    rating: 8.8,
    popularity: 6890,
    updateDate: "2024-12-24",
    duration: "110分钟",
  },

  // ===== 电视剧 =====
  {
    id: "v-city-life",
    title: "都市浮生记",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20TV%20series%20poster%2C%20confident%20young%20professionals%20on%20city%20rooftop%20at%20dusk%2C%20glowing%20pink%20sunset%20skyline%2C%20stylish%20fashion%2C%20cinematic%20contemporary%20composition%2C%20warm%20hopeful%20tone&width=600&height=900&seq=pinkv-tv-01&orientation=portrait",
    category: "tv",
    genre: ["都市", "情感", "职场"],
    year: 2025,
    region: "中国大陆",
    cast: ["黎晓棠", "顾言深", "沈亦舟"],
    director: "冯远洲",
    description:
      "四个性格迥异的年轻人在大城市打拼，合租在同一间老旧的公寓里。他们分享加班的深夜、恋爱的烦恼与梦想的追逐，用彼此的陪伴对抗生活的疲惫。这是一部献给所有城市奋斗者的温暖群像剧。",
    status: "连载",
    rating: 8.6,
    popularity: 9450,
    updateDate: "2025-09-28",
    duration: "全42集",
  },
  {
    id: "v-mountains-rivers",
    title: "山河故人",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20Chinese%20period%20drama%20poster%2C%20ancient%20scholar%20in%20flowing%20robe%20by%20misty%20mountains%20and%20river%2C%20ink%20painting%20style%20with%20pink%20blossom%20accents%2C%20poetic%20grand%20atmosphere%2C%20refined%20elegant%20composition&width=600&height=900&seq=pinkv-tv-02&orientation=portrait",
    category: "tv",
    genre: ["古装", "历史", "剧情"],
    year: 2024,
    region: "中国大陆",
    cast: ["陆知衡", "温亦柔", "程锦书"],
    director: "司马昭",
    description:
      "动荡年代，书香门第的陆知衡弃笔从戎，只为守护心中的山河。他经历战火、离别与背叛，始终未曾放下对家国的赤诚。一曲荡气回肠的家国长歌，诉说乱世中的赤子之心。",
    status: "完结",
    rating: 9.2,
    popularity: 8380,
    updateDate: "2024-12-30",
    duration: "全56集",
  },
  {
    id: "v-crime-files",
    title: "刑侦档案",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20drama%20poster%2C%20detective%20team%20examining%20evidence%20board%20in%20dim%20office%2C%20cold%20blue%20shadow%20with%20pink%20accent%20light%2C%20tense%20procedural%20tone%2C%20moody%20cinematic%20lighting&width=600&height=900&seq=pinkv-tv-03&orientation=portrait",
    category: "tv",
    genre: ["悬疑", "刑侦", "犯罪"],
    year: 2025,
    region: "中国大陆",
    cast: ["秦墨白", "楚云棠", "严明允"],
    director: "谢承泽",
    description:
      "市局重案组接手一起看似普通的案件，却意外牵扯出尘封多年的连环谜案。法医、刑警、心理侧写师组成黄金搭档，用科学与人性的双重透镜破解真相，还原每一个被掩埋的正义。",
    status: "连载",
    rating: 8.9,
    popularity: 8970,
    updateDate: "2025-10-05",
    duration: "更新至28集",
  },
  {
    id: "v-blooming",
    title: "繁花似锦",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20period%20drama%20poster%2C%20elegant%20woman%20in%20vintage%20Chinese%20dress%20among%20blooming%20pink%20flowers%2C%20soft%20dreamy%20lighting%2C%20romantic%20nostalgic%20tone%2C%20delicate%20floral%20composition%2C%20refined%20artistic%20atmosphere&width=600&height=900&seq=pinkv-tv-04&orientation=portrait",
    category: "tv",
    genre: ["爱情", "民国", "剧情"],
    year: 2024,
    region: "中国大陆",
    cast: ["苏锦年", "江书棠", "霍明轩"],
    director: "陆晚晴",
    description:
      "民国上海，名门千金苏锦年与进步青年江书棠在动荡的时局中相识相知。家族恩怨、时代洪流与炙热爱意交织，他们在时代的缝隙中守护着彼此。一段华丽又心碎的乱世情缘。",
    status: "完结",
    rating: 8.5,
    popularity: 7760,
    updateDate: "2024-09-18",
    duration: "全48集",
  },
  {
    id: "v-healer-heart",
    title: "医者仁心",
    cover:
      "https://readdy.ai/api/search-image?query=medical%20drama%20TV%20series%20poster%2C%20determined%20young%20doctor%20in%20white%20coat%20in%20hospital%20corridor%2C%20clean%20bright%20lighting%20with%20soft%20pink%20accent%2C%20hopeful%20professional%20atmosphere%2C%20cinematic%20warm%20tone&width=600&height=900&seq=pinkv-tv-05&orientation=portrait",
    category: "tv",
    genre: ["医疗", "剧情", "职场"],
    year: 2025,
    region: "中国大陆",
    cast: ["许晨曦", "段明泽", "梁心怡"],
    director: "阮清和",
    description:
      "急诊科医生许晨曦每天与时间赛跑，在生死一线间见证人性的光辉与脆弱。面对医疗资源、医患关系与个人理想的多重考验，她始终坚守那份治病救人的初心。",
    status: "连载",
    rating: 9.0,
    popularity: 8150,
    updateDate: "2025-09-20",
    duration: "更新至35集",
  },
  {
    id: "v-youth-jianghu",
    title: "少年江湖",
    cover:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20drama%20poster%2C%20young%20swordsman%20in%20flowing%20white%20robes%20on%20bamboo%20forest%20cliff%2C%20pink%20petals%20flying%2C%20dynamic%20wind%20motion%2C%20epic%20fantasy%20composition%2C%20dramatic%20lighting&width=600&height=900&seq=pinkv-tv-06&orientation=portrait",
    category: "tv",
    genre: ["武侠", "古装", "青春"],
    year: 2024,
    region: "中国大陆",
    cast: ["白子墨", "林清瑶", "楚摇光"],
    director: "独孤逸",
    description:
      "江湖传闻，失传多年的绝世秘籍重现世间。初出茅庐的少年白子墨为寻师父下落踏入江湖，结识了一众肝胆相照的伙伴。刀光剑影之间，他们用热血书写属于自己的侠义传说。",
    status: "完结",
    rating: 8.3,
    popularity: 7020,
    updateDate: "2024-07-22",
    duration: "全40集",
  },
  {
    id: "v-misty-city",
    title: "迷雾之城",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20suspense%20drama%20poster%2C%20foggy%20night%20cityscape%20with%20glowing%20pink%20streetlights%2C%20lone%20figure%20walking%20away%2C%20eerie%20tense%20atmosphere%2C%20cinematic%20dark%20mood%2C%20moody%20blue%20pink%20contrast&width=600&height=900&seq=pinkv-tv-07&orientation=portrait",
    category: "tv",
    genre: ["悬疑", "科幻", "惊悚"],
    year: 2025,
    region: "中国大陆",
    cast: ["闻时雨", "靳南风", "阮清月"],
    director: "霍司年",
    description:
      "一座每年只有三天被浓雾笼罩的城市，每逢迷雾降临，都会有人神秘失踪。记者闻时雨决心揭开迷雾背后的真相，却发现整座城市都藏着一个不愿被提及的秘密。",
    status: "连载",
    rating: 8.8,
    popularity: 8340,
    updateDate: "2025-10-12",
    duration: "更新至22集",
  },
  {
    id: "v-homeward-train",
    title: "归途列车",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20family%20drama%20poster%2C%20passenger%20train%20traveling%20through%20golden%20sunset%20countryside%2C%20silhouette%20of%20traveler%20by%20window%2C%20nostalgic%20pink%20amber%20tones%2C%20emotional%20heartwarming%20atmosphere%2C%20cinematic%20composition&width=600&height=900&seq=pinkv-tv-08&orientation=portrait",
    category: "tv",
    genre: ["家庭", "剧情", "治愈"],
    year: 2024,
    region: "中国大陆",
    cast: ["程远航", "沈念安", "老周"],
    director: "钱守正",
    description:
      "一列穿越南北的绿皮火车上，形形色色的旅客带着各自的故事踏上归途。列车员程远航用一路的陪伴，串联起关于亲情、乡愁与重逢的温暖片段。每一次到站，都是一次心的靠近。",
    status: "完结",
    rating: 9.1,
    popularity: 7280,
    updateDate: "2024-06-10",
    duration: "全36集",
  },

  // ===== 综艺 =====
  {
    id: "v-music-live",
    title: "奇妙音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=music%20live%20show%20variety%20poster%2C%20singer%20performing%20on%20stage%20under%20pink%20spotlights%20and%20confetti%2C%20energetic%20concert%20atmosphere%2C%20dynamic%20colorful%20lighting%2C%20vibrant%20cinematic%20composition&width=600&height=900&seq=pinkv-var-01&orientation=portrait",
    category: "variety",
    genre: ["音乐", "竞演", "真人秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["苏乐言", "程以宁", "阿哲"],
    director: "王牌制作组",
    description:
      "来自不同领域的音乐人齐聚舞台，用一场场live演出碰撞出奇妙的火花。没有淘汰、没有剧本，只有纯粹的音乐与真挚的表达。每周五晚，一起沉浸在声音的奇妙世界。",
    status: "连载",
    rating: 8.9,
    popularity: 9260,
    updateDate: "2025-10-10",
    duration: "更新至第9期",
  },
  {
    id: "v-food-quest",
    title: "美食奇遇记",
    cover:
      "https://readdy.ai/api/search-image?query=food%20travel%20variety%20poster%2C%20colorful%20street%20food%20stall%20with%20steaming%20dishes%20and%20warm%20lights%2C%20chef%20holding%20dish%2C%20appetizing%20vibrant%20tones%2C%20joyful%20warm%20atmosphere%2C%20cinematic%20food%20photography&width=600&height=900&seq=pinkv-var-02&orientation=portrait",
    category: "variety",
    genre: ["美食", "旅行", "真人秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["何味之", "林小满", "老陈"],
    director: "味觉工作室",
    description:
      "三位主持人走遍大江南北，寻找藏在街头巷尾的烟火美味。从清晨的早点摊到深夜的排档，每一道菜背后都有一个关于生活与人情的故事。跟着他们一起，用味蕾丈量世界。",
    status: "连载",
    rating: 8.7,
    popularity: 8640,
    updateDate: "2025-09-30",
    duration: "更新至第12期",
  },
  {
    id: "v-run-friends",
    title: "奔跑吧朋友们",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20game%20show%20variety%20poster%2C%20group%20of%20cheerful%20young%20people%20running%20and%20laughing%20in%20colorful%20park%2C%20bright%20daylight%20with%20pink%20accents%2C%20energetic%20fun%20atmosphere%2C%20dynamic%20action%20composition&width=600&height=900&seq=pinkv-var-03&orientation=portrait",
    category: "variety",
    genre: ["户外", "竞技", "真人秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["邓乐天", "杨开心", "黄小磊"],
    director: "奔跑制作组",
    description:
      "七位性格各异的嘉宾组成固定班底，每期挑战一个脑洞大开的户外任务。撕名牌、闯关赛、城市追击轮番上演，笑料与惊喜齐飞。这是一档让人笑到停不下来的国民综艺。",
    status: "连载",
    rating: 8.5,
    popularity: 9680,
    updateDate: "2025-10-14",
    duration: "更新至第10期",
  },
  {
    id: "v-detective-club",
    title: "明星大侦探社",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20game%20show%20variety%20poster%2C%20detective%20theme%20stage%20with%20magnifying%20glass%20clues%20and%20moody%20pink%20violet%20lighting%2C%20dramatic%20whodunit%20atmosphere%2C%20theatrical%20cinematic%20composition%2C%20stylish%20design&width=600&height=900&seq=pinkv-var-04&orientation=portrait",
    category: "variety",
    genre: ["推理", "悬疑", "真人秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["何推理", "撒聪明", "白逻辑"],
    director: "谜案制作组",
    description:
      "每期一桩离奇案件，六位嘉宾化身侦探潜入现场，通过搜证、举证与推理找出真凶。烧脑的剧情与机智的博弈并存，烧脑又爆笑。你，能比他们更早破解真相吗？",
    status: "连载",
    rating: 9.2,
    popularity: 9520,
    updateDate: "2025-10-08",
    duration: "更新至第8期",
  },
  {
    id: "v-wild-survival",
    title: "荒野求生挑战",
    cover:
      "https://readdy.ai/api/search-image?query=survival%20reality%20show%20poster%2C%20adventurer%20building%20campfire%20in%20wild%20mountain%20wilderness%20at%20dusk%2C%20dramatic%20pink%20orange%20sky%2C%20rugged%20epic%20atmosphere%2C%20cinematic%20documentary%20lighting%2C%20gritty%20adventure%20tone&width=600&height=900&seq=pinkv-var-05&orientation=portrait",
    category: "variety",
    genre: ["户外", "求生", "纪实"],
    year: 2024,
    region: "中国大陆",
    cast: ["野外老张", "探险家阿凯", "刘晓岚"],
    director: "荒野工作室",
    description:
      "六位明星嘉宾被空降到无人荒野，仅带少量工具，必须在七天内存活并完成救援任务。生火、觅食、搭建庇护所，真实呈现人在极限环境下的协作与成长。",
    status: "完结",
    rating: 8.4,
    popularity: 7180,
    updateDate: "2024-11-30",
    duration: "全12期",
  },
  {
    id: "v-comedy-night",
    title: "喜剧之王夜",
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20show%20variety%20poster%2C%20comedian%20performers%20on%20brightly%20lit%20stage%20with%20pink%20and%20gold%20confetti%2C%20joyful%20laughing%20atmosphere%2C%20colorful%20energetic%20stage%20design%2C%20theatrical%20composition&width=600&height=900&seq=pinkv-var-06&orientation=portrait",
    category: "variety",
    genre: ["喜剧", "竞演", "脱口秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["李逗趣", "王小乐", "张哈哈"],
    director: "欢乐工场",
    description:
      "全国最会讲笑话的人聚在一起，用段子决一高下。脱口秀、即兴喜剧、情景短剧轮番登场，每一秒都在制造快乐。工作再累，也要笑着看完这一夜。",
    status: "连载",
    rating: 8.6,
    popularity: 8420,
    updateDate: "2025-10-06",
    duration: "更新至第11期",
  },
  {
    id: "v-parenting-camp",
    title: "亲子成长营",
    cover:
      "https://readdy.ai/api/search-image?query=family%20reality%20show%20poster%2C%20parent%20and%20child%20playing%20together%20in%20sunny%20green%20meadow%20with%20pastel%20pink%20flowers%2C%20heartwarming%20joyful%20atmosphere%2C%20soft%20warm%20lighting%2C%20tender%20family%20composition&width=600&height=900&seq=pinkv-var-07&orientation=portrait",
    category: "variety",
    genre: ["亲子", "治愈", "真人秀"],
    year: 2025,
    region: "中国大陆",
    cast: ["暖心家庭团", "小星星", "小月亮"],
    director: "成长工作室",
    description:
      "六组明星家庭离开城市，来到山野营地共同生活。萌娃与爸妈在农耕、手作、野外游戏中体验成长，也让屏幕前的每个家庭重新思考陪伴的意义。",
    status: "连载",
    rating: 8.3,
    popularity: 6940,
    updateDate: "2025-09-26",
    duration: "更新至第7期",
  },
  {
    id: "v-traveler-secret",
    title: "旅行者的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=travel%20documentary%20variety%20poster%2C%20traveler%20standing%20on%20cliff%20overlooking%20misty%20valley%20at%20sunrise%20with%20pink%20dawn%20sky%2C%20backpack%20and%20map%2C%20wanderlust%20cinematic%20atmosphere%2C%20breathtaking%20scenery&width=600&height=900&seq=pinkv-var-08&orientation=portrait",
    category: "variety",
    genre: ["旅行", "纪实", "文化"],
    year: 2024,
    region: "中国大陆",
    cast: ["旅人小林", "摄影师老杨", "向导阿木"],
    director: "远方制作组",
    description:
      "每一个目的地都藏着一个等待被发现的秘密。摄制组深入人迹罕至的秘境，记录当地的风土人情与动人故事。这不仅是一场旅行，更是一次与世界的深情对话。",
    status: "完结",
    rating: 8.8,
    popularity: 6680,
    updateDate: "2024-10-20",
    duration: "全10期",
  },
];

export interface HeroSlide {
  id: string;
  videoId: string;
  title: string;
  tagline: string;
  subtitle: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    videoId: "v-star-promise",
    title: "星辰之约",
    tagline: "科幻巨制 · 跨越星河的浪漫",
    subtitle: "当宇宙的浩瀚遇见十年的守候，一场关于爱与时间的史诗就此展开。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20panorama%2C%20lone%20silhouette%20under%20vast%20starry%20night%20sky%20with%20glowing%20pink%20and%20magenta%20nebula%2C%20epic%20wide%20composition%2C%20dramatic%20deep%20dark%20background%20with%20strong%20color%20contrast%2C%20atmospheric%20high%20detail&width=1920&height=1080&seq=pinkv-hero-01&orientation=landscape",
  },
  {
    id: "h2",
    videoId: "v-detective-club",
    title: "明星大侦探社",
    tagline: "全网口碑综艺 · 烧脑来袭",
    subtitle: "六位侦探闯入谜案现场，每一次搜证都可能改写真相。",
    image:
      "https://readdy.ai/api/search-image?query=theatrical%20mystery%20stage%20panorama%2C%20dramatic%20moody%20lighting%20with%20pink%20and%20magenta%20spotlights%2C%20whodunit%20scene%20with%20clues%20and%20props%2C%20cinematic%20wide%20composition%2C%20dark%20background%20with%20strong%20contrast&width=1920&height=1080&seq=pinkv-hero-02&orientation=landscape",
  },
  {
    id: "h3",
    videoId: "v-changan-wind",
    title: "风起长安",
    tagline: "史诗古装 · 家国天下",
    subtitle: "盛世之下暗流涌动，他用刀剑守护心中的家国大义。",
    image:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20Chinese%20palace%20panorama%20at%20crimson%20and%20pink%20sunset%2C%20grand%20architecture%20silhouettes%2C%20dramatic%20cinematic%20wide%20composition%2C%20rich%20dark%20tonal%20contrast%2C%20majestic%20atmospheric%20mood&width=1920&height=1080&seq=pinkv-hero-03&orientation=landscape",
  },
  {
    id: "h4",
    videoId: "v-city-life",
    title: "都市浮生记",
    tagline: "热播都市剧 · 温暖群像",
    subtitle: "四个年轻人，一间公寓，对抗生活的所有疲惫与浪漫。",
    image:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20panorama%20at%20dusk%20with%20glowing%20pink%20and%20orange%20sunset%20reflections%2C%20rooftop%20silhouettes%2C%20cinematic%20wide%20composition%2C%20dramatic%20atmospheric%20contrast%2C%20warm%20hopeful%20mood&width=1920&height=1080&seq=pinkv-hero-04&orientation=landscape",
  },
  {
    id: "h5",
    videoId: "v-food-quest",
    title: "美食奇遇记",
    tagline: "治愈综艺 · 寻味人间",
    subtitle: "跟着味蕾去旅行，每一道菜背后都有一个温暖的故事。",
    image:
      "https://readdy.ai/api/search-image?query=night%20street%20food%20market%20panorama%20with%20warm%20steaming%20stalls%20and%20pink%20neon%20lanterns%2C%20cinematic%20wide%20composition%2C%20vibrant%20appetizing%20atmosphere%2C%20dark%20background%20with%20rich%20color%20contrast&width=1920&height=1080&seq=pinkv-hero-05&orientation=landscape",
  },
];

export const genreOptions: Record<VideoCategory, string[]> = {
  movie: ["动作", "爱情", "科幻", "悬疑", "剧情", "历史", "冒险", "犯罪", "奇幻"],
  tv: ["都市", "古装", "悬疑", "爱情", "剧情", "武侠", "医疗", "家庭", "刑侦"],
  variety: ["音乐", "美食", "推理", "户外", "竞技", "喜剧", "亲子", "旅行", "纪实"],
};

export const yearOptions = [2025, 2024, 2023];

export const getVideosByCategory = (category: VideoCategory): VideoItem[] =>
  videos.filter((v) => v.category === category);

export const getVideoById = (id: string): VideoItem | undefined =>
  videos.find((v) => v.id === id);

export const getRelatedVideos = (video: VideoItem, count = 5): VideoItem[] => {
  const sameCategory = videos.filter(
    (v) => v.category === video.category && v.id !== video.id
  );
  const scored = sameCategory.map((v) => {
    const overlap = v.genre.filter((g) => video.genre.includes(g)).length;
    return { v, overlap };
  });
  scored.sort((a, b) => b.overlap - a.overlap || b.v.popularity - a.v.popularity);
  return scored.slice(0, count).map((s) => s.v);
};

export const hotVideos = [...videos].sort((a, b) => b.popularity - a.popularity).slice(0, 12);

export const latestVideos = [...videos]
  .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1))
  .slice(0, 10);